export const MY_SUBSCRIPTIONS_CATEGORY_ID = 'subscriptions';
